module.exports = __webpack_public_path__ + "img/logo.5f69a1e5.svg";